<template>
    <div class="brand-target">
        <div class="section-content" style="margin-bottom: 140px;">
            <img src="../../assets/imgs/brand/brand-target.png" style="width: 100%;"/>
        </div>
       <div class="bgImg">
           <div style="height:160px;background-color: #f9be43;"></div>
           <div class="bg"></div>
       </div>
       <div class="section-content">
           <div class="flexAlign" style="width: 860px;margin: 0px auto;margin-bottom: 60px;">
               <div style="width: 440px;display: inline-block;">
                   <div class="target-title">
                       Holistic education
                       <div class="title">全人格教育</div>
                       <div>七田真倡导的全人格教育包括身体、人格和智力。 七田真和父母一起，努力培养孩子健康的身体、 健全的人格和卓越的智力。  </div>
                       <span style="display: inline-block;width:80px;height: 0px;border-bottom: 8px solid #f9be43;"></span>
                   </div>
               </div>
               <div style="width: 380px;display: inline-block;"><img src="../../assets/imgs/brand/target-san.png" style="width: 80%;margin-left: 10%;" /> </div>
           </div>
       </div>
    </div>
</template>
<script>
 export default {
     data(){
         return{

         }
     }
 }

</script>
<style scoped lang='less'>
    .brand-target{
       position: relative;
        .bgImg{
            position: absolute;
            top: 242px;
            left: 0px;
            z-index: -10;
            width: 100%;
            /*height: 600px;*/
            .bg{
                height:300px;
                background: url("../../assets/imgs/bg-bottom.png") repeat-x;
            }

        }
        .target-title{
            color: #fbc200;
            font-size: 30px;
            font-weight: 600;
            .title{
                color: #3e3a39;
                font-size: 40px;
                font-weight: 600;
                margin: 8px 0px 40px;
            }
            div{
                line-height: 34px;
                margin-bottom: 10px;
                font-family: Light;
                font-size: 20px;
                color: #5e5e5e;
            }
        }
    }
</style>
